import {useDisclosure} from '@mantine/hooks';
import {MdAddCircleOutline} from 'react-icons/md';
import {
  COLOR_PRIMARY_2,
  COLOR_WHITE,
} from '../../../config/constants/colorCodes';
import {useAuth} from '../../../core/usecases/useAuth';
import {useHandleFollowCompany} from '../../../core/usecases/useHandleFollowCompany';
import {cn} from '../../../lib/classname';
import {NoLoginAlertModal} from '../NoLoginAlertModal';

type Props = {
  companyId: number;
  initialFollowerCount: number;
  isInitiallyFollowed: boolean;
};

export const FollowCompanyTypeC: React.FC<Props> = ({
  companyId,
  initialFollowerCount,
  isInitiallyFollowed,
}) => {
  const {isSignedIn} = useAuth();
  const [opened, {open, close}] = useDisclosure(false);
  const {handleFollowCompany, followCountUpdated, isFollowed} =
    useHandleFollowCompany({
      companyId,
      followCount: initialFollowerCount,
      followed: isInitiallyFollowed,
    });

  const onClick = async () => {
    if (!isSignedIn) {
      open();
      return;
    }

    return handleFollowCompany();
  };

  return (
    <>
      <button
        className={cn(
          'p-8 flex w-[150px] items-center justify-center gap-4 rounded-[20px] border-2 border-primary-2',
          {
            'bg-primary-2 text-white': isFollowed,
            'bg-white text-primary-2': !isFollowed,
          },
        )}
        type="button"
        onClick={onClick}
      >
        <MdAddCircleOutline
          color={isFollowed ? COLOR_WHITE : COLOR_PRIMARY_2}
          size="16px"
        />
        <span className="font-bold text-base">
          {isFollowed ? 'フォロー中' : 'フォロー'}
        </span>
        <span className="text-sm">{followCountUpdated}</span>
      </button>
      <NoLoginAlertModal opened={opened} onClose={close} />
    </>
  );
};
